export default __webpack_public_path__ + "static/media/notFound.805ca092.jpg";